import { EStatus } from '../enums/EStatus';
import { IItemStatus } from './IItemStatus';

export enum ECampaignType {
  Partner = 'Partner',
  NonPartner = 'Non-partner',
}

export enum ECampaignCodeType {
  Generic = 'Generic',
  Unique = 'Unique',
}

export declare namespace NSPromoCampaigns {
  interface ITableItem {
    _id: string;
    publicCode: string;
    internalName: string;
    targetPackage: string;
    targetPackageId: string;
    status: EStatus;
    type: ECampaignType;
    codeType: ECampaignCodeType;
    generatedCodeCount: number;
    insertedCodeCount: number;
    usedCodeCount: number;
  }

  interface IFormattedItem {
    _id: string;
    publicCode: string;
    internalName: string;
    targetPackage: string;
    status: EStatus;
    type: ECampaignType;
    codeType: ECampaignCodeType;
    generatedCodeCount: number;
    insertedCodeCount: number;
    usedCodeCount: number;
  }

  interface IData {
    page: number;
    table: ITableItem[];
    total: number;
    totalPage: number;
  }

  export interface IDetails {
    _id: string;
    publicCode: string;
    internalName: string;
    targetPackageId: string;
    technicalCode: string;
    affiliateCode: string;
    oncePerUser: boolean;
    oncePerDevice: boolean;
    activationDate: string;
    promoCodePrefix: string;
    status: IItemStatus;
    type: ECampaignType;
    codeType: ECampaignCodeType;
    generatedCodeCount: number;
    insertedCodeCount: number;
    usedCodeCount: number;
  }
}

export const CAMPAIGN_CODE_TYPE_OPTIONS = [
  { value: ECampaignCodeType.Generic, label: 'Generic' },
  { value: ECampaignCodeType.Unique, label: 'Unique' },
];

export const CAMPAIGN_TYPE_OPTIONS = [
  { value: ECampaignType.Partner, label: 'Partner' },
  { value: ECampaignType.NonPartner, label: 'Non-partner' },
];
